import { postRequest } from '@/core';
import { orderTypes } from '@/requests';

export default async function syncOrderTypes() {
	let url = orderTypes.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}